import React from 'react'
import { SuccessPage } from 'components'

export default function FBSuccess() {
  return <SuccessPage />
}
